// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueHead from 'vue-head'
import VueMq from 'vue-mq'

Vue.config.productionTip = false

Vue.use(VueHead)
Vue.use(VueMq, {
  breakpoints: {
    sp: 480,
    pc: Infinity
  },
  defaultBreakpoint: 'pc'
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js